"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingsHomeDtoLandAreaUnitEnum = exports.ListingsHomeDtoCampaignEnum = exports.ListingsHomeDtoAuctionStatusEnum = exports.ListingsHomeDtoListingStatusEnum = exports.ListingsHomeDtoListingTypeEnum = void 0;
exports.instanceOfListingsHomeDto = instanceOfListingsHomeDto;
exports.ListingsHomeDtoFromJSON = ListingsHomeDtoFromJSON;
exports.ListingsHomeDtoFromJSONTyped = ListingsHomeDtoFromJSONTyped;
exports.ListingsHomeDtoToJSON = ListingsHomeDtoToJSON;
exports.ListingsHomeDtoToJSONTyped = ListingsHomeDtoToJSONTyped;
var LovableExtrasDto_1 = require("./LovableExtrasDto");
var ListingMediaDto_1 = require("./ListingMediaDto");
/**
 * @export
 */
exports.ListingsHomeDtoListingTypeEnum = {
    PrivateSale: 'private_sale',
    Auction: 'auction',
    ReverseAuction: 'reverse_auction'
};
/**
 * @export
 */
exports.ListingsHomeDtoListingStatusEnum = {
    Draft: 'draft',
    Active: 'active',
    UnderOffer: 'under_offer',
    OffTheMarket: 'off_the_market',
    PassedIn: 'passed_in',
    Disabled: 'disabled',
    Deleted: 'deleted',
    Sold: 'sold'
};
/**
 * @export
 */
exports.ListingsHomeDtoAuctionStatusEnum = {
    ToBeStarted: 'to_be_started',
    InProgress: 'in_progress',
    Paused: 'paused',
    Completed: 'completed',
    Cancelled: 'cancelled'
};
/**
 * @export
 */
exports.ListingsHomeDtoCampaignEnum = {
    VendorManaged: 'vendor_managed',
    UnreservedManaged: 'unreserved_managed'
};
/**
 * @export
 */
exports.ListingsHomeDtoLandAreaUnitEnum = {
    M: 'm',
    Sqm: 'sqm',
    Acre: 'acre',
    Hectare: 'hectare'
};
/**
 * Check if a given object implements the ListingsHomeDto interface.
 */
function instanceOfListingsHomeDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('propertyId' in value) || value['propertyId'] === undefined)
        return false;
    if (!('isValuationListing' in value) || value['isValuationListing'] === undefined)
        return false;
    if (!('listingType' in value) || value['listingType'] === undefined)
        return false;
    if (!('listingStatus' in value) || value['listingStatus'] === undefined)
        return false;
    if (!('displayPrice' in value) || value['displayPrice'] === undefined)
        return false;
    return true;
}
function ListingsHomeDtoFromJSON(json) {
    return ListingsHomeDtoFromJSONTyped(json, false);
}
function ListingsHomeDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'propertyId': json['propertyId'],
        'title': json['title'] == null ? undefined : json['title'],
        'isValuationListing': json['isValuationListing'],
        'description': json['description'] == null ? undefined : json['description'],
        'listingType': json['listingType'],
        'listingStatus': json['listingStatus'],
        'auctionStatus': json['auctionStatus'] == null ? undefined : json['auctionStatus'],
        'auctionStartPrice': json['auctionStartPrice'] == null ? undefined : json['auctionStartPrice'],
        'auctionStartDate': json['auctionStartDate'] == null ? undefined : json['auctionStartDate'],
        'price': json['price'] == null ? undefined : json['price'],
        'displayPrice': json['displayPrice'],
        'priceText': json['priceText'] == null ? undefined : json['priceText'],
        'campaign': json['campaign'] == null ? undefined : json['campaign'],
        'address': json['address'] == null ? undefined : json['address'],
        'carPorts': json['carPorts'] == null ? undefined : json['carPorts'],
        'openParkingSpaces': json['openParkingSpaces'] == null ? undefined : json['openParkingSpaces'],
        'bedrooms': json['bedrooms'] == null ? undefined : json['bedrooms'],
        'bathrooms': json['bathrooms'] == null ? undefined : json['bathrooms'],
        'toilets': json['toilets'] == null ? undefined : json['toilets'],
        'garages': json['garages'] == null ? undefined : json['garages'],
        'ensuites': json['ensuites'] == null ? undefined : json['ensuites'],
        'landArea': json['landArea'] == null ? undefined : json['landArea'],
        'landArea_unit': json['landArea_unit'] == null ? undefined : json['landArea_unit'],
        'soldPrice': json['soldPrice'] == null ? undefined : json['soldPrice'],
        'highestBidPrice': json['highestBidPrice'] == null ? undefined : json['highestBidPrice'],
        'highestOfferPrice': json['highestOfferPrice'] == null ? undefined : json['highestOfferPrice'],
        'media': json['media'] == null ? undefined : (0, ListingMediaDto_1.ListingMediaDtoFromJSON)(json['media']),
        'registeredInspectionsCount': json['registeredInspectionsCount'] == null ? undefined : json['registeredInspectionsCount'],
        'publishedAt': json['publishedAt'] == null ? undefined : json['publishedAt'],
        'lovableExtras': json['lovableExtras'] == null ? undefined : (0, LovableExtrasDto_1.LovableExtrasDtoFromJSON)(json['lovableExtras']),
        'lovableExtrasAddedOn': json['lovableExtrasAddedOn'] == null ? undefined : json['lovableExtrasAddedOn'],
    };
}
function ListingsHomeDtoToJSON(json) {
    return ListingsHomeDtoToJSONTyped(json, false);
}
function ListingsHomeDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'slug': value['slug'],
        'propertyId': value['propertyId'],
        'title': value['title'],
        'isValuationListing': value['isValuationListing'],
        'description': value['description'],
        'listingType': value['listingType'],
        'listingStatus': value['listingStatus'],
        'auctionStatus': value['auctionStatus'],
        'auctionStartPrice': value['auctionStartPrice'],
        'auctionStartDate': value['auctionStartDate'],
        'price': value['price'],
        'displayPrice': value['displayPrice'],
        'priceText': value['priceText'],
        'campaign': value['campaign'],
        'address': value['address'],
        'carPorts': value['carPorts'],
        'openParkingSpaces': value['openParkingSpaces'],
        'bedrooms': value['bedrooms'],
        'bathrooms': value['bathrooms'],
        'toilets': value['toilets'],
        'garages': value['garages'],
        'ensuites': value['ensuites'],
        'landArea': value['landArea'],
        'landArea_unit': value['landArea_unit'],
        'soldPrice': value['soldPrice'],
        'highestBidPrice': value['highestBidPrice'],
        'highestOfferPrice': value['highestOfferPrice'],
        'media': (0, ListingMediaDto_1.ListingMediaDtoToJSON)(value['media']),
        'registeredInspectionsCount': value['registeredInspectionsCount'],
        'publishedAt': value['publishedAt'],
        'lovableExtras': (0, LovableExtrasDto_1.LovableExtrasDtoToJSON)(value['lovableExtras']),
        'lovableExtrasAddedOn': value['lovableExtrasAddedOn'],
    };
}
